import React, { useState } from 'react';
import IconItem from 'components/common/icon/IconItem';
import axios from "axios";
import { useEffect } from 'react'
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import moment from 'moment';
import { toast } from 'react-toastify';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Col } from 'react-bootstrap';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import TableShimmer from './TableShimmer';

const DiseaseCodeTable = (props) => {

    function handleEditInput(editValue) {
        //console.log("I m in Handle Edit " + editValue);
        props.onCallEditParent(editValue);
    }

    const columns = [
        {
            accessorKey: 'priority',
            header: 'Vitals',
            meta: {
                headerProps: { className: 'pe-1 col-lg-8 text-start text-900' }
            }
        },
        // {
        //     accessorKey: 'updated_by',
        //     header: 'Updated By',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        // {
        //     accessorKey: 'updatedate',
        //     header: 'Updated Date',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        // {
        //     accessorKey: 'Action',
        //     header: '',
        //     meta: {
        //         headerProps: {
        //             className: 'text-900'
        //         },
        //         cellProps: {
        //             className: 'align-items-center'
        //         }
        //     },
        //     enableSorting: false,
        //     cell: ({ row: { original } }) => {
        //         return Number(localStorage.getItem("roleId")) < 4 && <IconItem
        //             tag="button"
        //             icon={['far', 'edit']}
        //             size="sm"
        //             onClick={() => handleEditInput({
        //                 priority: original.priority,
        //                 is_active: original.is_active,
        //                 insurancepriority_id: original.insurancepriority_id
        //             })}
        //             className="btn rounded-3 me-2 fs-11 align-items-center"
        //         />
        //     }
        // }
    ];

    const [insurancepriority, setInsurancePriority] = useState([]);
    const [error, setError] = useState(true);
    const [loader, setLoader] = useState(false);
    // const [showModal, setShowModal] = useState(false);

    // const handleEditInsurancePriorityModal = (insurancepriorityValue, isActive, insurancepriorityId) => {
    //     localStorage.setItem("insurancepriorityValue", insurancepriorityValue);
    //     localStorage.setItem("insurancepriorityId", insurancepriorityId);
    //     localStorage.setItem("isActive", isActive);
    //     setShowModal(true);
    // };

    useEffect(() => {

        async function fetchInsPrDetails() {
            setLoader(true);
            let tokenStr = localStorage.getItem("accessToken");

            try {
                let payload = {
                    vitals : {},
                }
                const { data } = await axios.post(`${process.env.REACT_APP_SERVER_URL}` + "/prescriptions/fetch-multiple", payload, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
                const results = []
                const insurancepriorityData = data.output.data.vitals;

                //console.log("patient_insurance_priorities " + data.patient_insurance_priorities.status + ',' + data.patient_insurance_priorities.data);

                if (data.output.status) {
                    insurancepriorityData.forEach((value) => {
                        let active_sts = value.is_active ? "active" : "inactive";
                        if (props.active_status == active_sts) {
                            results.push({
                                priority: value.name,
                                insurancepriority_id: value.id,
                                is_active: value.is_active
                                // updated_by: value.updated_by,
                                // updatedate: value.updated != null ? moment(value.updated, 'YYYY-MM-DD').format('MM/DD/YY') : null
                            });
                        }
                    });

                    if (results.length > 0) {
                        setInsurancePriority(results);
                        setError(true)
                    } else {
                        setError(false)
                    }
                }
                else {
                    toast.info("No Insurance Priority found in this list");
                }
            } catch (err) {
                toast.error("Error fetching Disease Code data");
                setLoader(false);
            } finally {
                setLoader(false);
            }
        }

        fetchInsPrDetails();

        async function refreshInsPrDetails() {
            fetchInsPrDetails();
        }

        if (props.trigger > 0) {
            //console.log(props.trigger);
            refreshInsPrDetails();
        }

    }, [props.trigger]);

    const table = useAdvanceTable({
        data: insurancepriority,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    return (
        <div>
            <AdvanceTableProvider {...table}>
                <Col xs="4" className="mb-3 ms-auto">
                    <AdvanceTableSearchBox placeholder="Search..." />
                </Col>
                {loader ? <TableShimmer/> :  error ? <AdvanceTable
                    headerClassName="bg-200 text-nowrap align-middle text-center"
                    rowClassName="text-nowrap align-middle "
                    tableProps={{
                        size: 'lg',
                        striped: true,
                        className: 'fs-10 mb-0'
                    }}
                /> : <div className="d-flex justify-content-center align-items-center text-center" style={{ height: '50px' }}>
                    <p className="text-danger fw-bold mb-0">There is no data available in the table</p>
                </div>}
                <div className="mt-3">
                    <AdvanceTableFooter
                        rowInfo
                        navButtons
                        rowsPerPageSelection
                    />
                </div>
            </AdvanceTableProvider>
        </div>
    );
};

export default DiseaseCodeTable;
